import parse from 'html-react-parser'
import useShortCode from './use-shortcode'

export const ShortCode = props => {

  const { attribs } = props

  const type = attribs['data-type']
  const typeid = attribs['data-typeid']
  const content = attribs['data-content']

  const value = useShortCode(type, typeid, content)
  .replace(/(?:\r\n|\r|\n)/g, '<br>')

  const parsedValue = parse(value)  

  return (
    <span className={`
      shortcode
    `}>
      { parsedValue }
    </span>
  )
}
